import { authInterceptor } from '../interceptors'

import instanceCommon from './common'

authInterceptor()

export const instances = { instanceCommon }
